import { render, staticRenderFns } from "./DTLoader.vue?vue&type=template&id=0d013b0d&"
import script from "./DTLoader.vue?vue&type=script&lang=js&"
export * from "./DTLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports